import { cx } from "./cx";

export interface TabItem<K extends string> {
  key: K;
  label: string;
}

/** A cream tab bar: each tab is a button, the active one is raised. */
export function Tabs<K extends string>({
  tabs,
  active,
  onChange,
}: {
  tabs: TabItem<K>[];
  active: K;
  onChange: (key: K) => void;
}) {
  return (
    <div
      role="tablist"
      className="flex max-w-full gap-1.5 self-start overflow-x-auto rounded-[11px] bg-[#faf6ef] p-1"
    >
      {tabs.map((t) => (
        <button
          key={t.key}
          role="tab"
          type="button"
          aria-selected={t.key === active}
          onClick={() => onChange(t.key)}
          className={cx(
            "shrink-0 rounded-lg px-4 py-[9px] text-sm whitespace-nowrap",
            t.key === active
              ? "bg-surface font-semibold text-fg shadow-xs"
              : "font-medium text-[#766e6a] hover:text-fg",
          )}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}
